module.exports = __webpack_public_path__ + "static/scale-model-of-tourist-scavenger-hunt-hollywood-in-glendale-california-24fad46402662d9d7583121060c7d1e8.png";